import React from 'react';

import * as ST from './styled';

interface ILink {
    text: string,
    dataTest?: string,
    onClick: () => void,
}

export const ListItemButton = ({ text, onClick, dataTest }: ILink) =>
    <ST.ListItemLi>
        <ST.ListItemButton onClick={onClick} data-test={dataTest}>{text}</ST.ListItemButton>
    </ST.ListItemLi>;
